// import callFunction, {
//   logout,
// } from "../../../public/common/vue/api/leanbot_js_api";
// import $ from "jquery";
// import WebsocketLeanbot from "../../../public/common/vue/api/leanbot.websocket";
// import * as paho_mqtt from "paho-mqtt";
import { computed, defineComponent } from "vue";
import axios from "axios";
import { asyncScheduler } from "rxjs";
import moment from "moment";
import AppBar from '@/views/components/appbar/appbar.vue'
import './histories.scss'
import { keycloakInit } from "@/services/api";
export default defineComponent({
  data() {
    var tab=0;
    return {

      usernamelogin: "",
      showReview: false,
      listMissionsData: { count:0, data: [] },
      page: 1,
      tab: tab,
      pageSize:20,
      loading: false,
      lastTab:tab,


      searchMission:null,
      missionNames:[],
      missionNameModel:null,
      controllerAxios:null,
      isPublicQuery:-1,
      

      usernameList:[],
      usernameModel:null,
     
     
      pageCount:computed(()=>{
        var a:any=this.listMissionsData;
        var ps:number=this.pageSize as any;
        
        if (a.data == undefined) return 1;
        if (a.data.length ==0) return 1;
        var rs=parseInt(`${(a.count+ps-1)/ps}`);
       
        return rs;
      })
     
    };
  },
  watch: {
    searchMission (val) {
      // debugger;
     this.searchMissionName(val)
    }
  },
  components:{
    AppBar
  },
  
  async mounted() {
    

    await keycloakInit.catch(console.error);
    document.querySelector('body').className="main-histories";
    this.usernamelogin = sessionStorage.getItem("USERNAME");
    
    await this.reloadTab(this.tab);

  },
  
  methods: {
    searchMissionName(msName:string) {
      // debugger;
      this.filterMissionName(msName).then((rs)=>{
        this.missionNames=rs;
      });
      // return ["1","2"]
    },
   
    missionValueFilter(itemTitle:any, queryText:any, item:any) {
      // debugger;
      // const textOne = item.raw.name.toLowerCase()
      // const textTwo = item.raw.abbr.toLowerCase()
      // console.log(item);
      var searchText = queryText.toLowerCase().trim();
    

      return itemTitle.toLowerCase().indexOf(searchText)!=-1;
    },
   
    getReplayLink(item: any) {
      var url = new URL(location.href);
      return `https://${url.hostname}/replay/${item.mission_run_id}`
    },
    
    reloadPage(page:number) {
      this.loadListMissions(this.tab,page);
    },
    async reloadTab(tab: any,missionName:any="",username:any="") {
      this.loading = true;
      this.page=1;
      var rs=await this.filterMissionName(missionName);
      this.missionNames=rs;
      if (tab==1) {
        this.usernameList=await this.filterUsername(username)
        // debugger;
      }
     
      
      this.loadListMissions(tab,1);
    },
    async filterMissionName(query:string) {
      var url = new URL(location.href);
      if (query=="all" || query=="" || query=="All") {
        query="";
      }
    //  console.log(query);
      url.searchParams.append("query",`${query||""}`.trim());
      if (this.tab==0) {
        url.searchParams.append("username",this.usernamelogin);
      }
      var rs= await axios.get("/logs/list-missions-names?"+url.searchParams.toString())
      .then(res=>res.data.map((o:any)=>{
        return {
          value:o.name,
          title:o.name
        }
      }));
      // debugger;
      return [{value:"",title:"All"},...rs];
    },
    async filterUsername(username:string) {
      var url = new URL(location.href);
     
      url.searchParams.append("username",`${username}`.trim());
     
      var rs= await axios.get("/logs/list-usernames?"+url.searchParams.toString())
      .then(res=>res.data.map((o:any)=>{
        return {
         
            title: o.username,
            value: o.username
        
        };
      }));
      // debugger;
      return [{value:"",title:"All"},...rs];
    },
    updatePublish(item: any) {
      return function (value: any) {
        console.log("public value:",value)
        axios.post("/logs/public-mission", { missionRunId: item.mission_run_id, public: value })
          .then(() => {
            item.is_public = value;
          }).catch(console.error)
      }
    },
    async loadListMissions(tab: any,page:any) {
      var cancelSource= axios.CancelToken.source();
// debugger;
      if (this.controllerAxios!=null) {
        // console.log("abort request")
        this.controllerAxios.cancel()
        // cancelSource.cancel
        // a.source().token
        // a.source().cancel()
       
        
      } 
     
      this.controllerAxios=cancelSource;
      this.loading = true;
      const tabval = ["ALL_MY_MISSION", "OTHERS_PUBLIC"];
      var query:any = { page};
      if (tab==0) {
        query.username= this.usernamelogin;

      } else {
        query.username= this.usernameModel;
      }
      if (this.missionNameModel) {
        query.missionName=this.missionNameModel;
        // debugger;
      }
      if (this.isPublicQuery!=-1) {
        query.isPublic=this.isPublicQuery
      }
    
      this.showReview = true;
      await axios.post(`/logs/list-missions`, query,{
        cancelToken:this.controllerAxios.token
        // signal: this.controllerAxios.signal
      }).then((res: any) => {

        this.listMissionsData = res.data;
        this.listMissionsData.data.forEach((o: any) => {
          o.hover = "Click to copy link";
          o.duration=parseFloat(o.duration).toFixed(1);

          ["created_at", "start_date", "updated_at"].forEach(field => {
            var ofs = moment().utcOffset() / 60;
            var a = moment(o[field]);
            var b = a.add(ofs, "hour");
            var c = b.format("YYYY-MM-DD HH:mm:ss");
            // debugger;
            o[field] = c;
          });

          return o;
        });
      }).catch(console.error);
      this.loading = false;
      // return this.listMissions({ queryType: tabval[tab],page: page  }).then(() => {
      //   this.loading = false;
      // });
    },
    
    copyToClipboard(item: any) {
      var link = this.getReplayLink(item)
      navigator.clipboard.writeText(link);
      var old = item.hover;
      item.hover = "Link copied";
      asyncScheduler.schedule(() => {
        item.hover = old;
      }, 1000)
    }


  }
});
